/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'

class TaskEditStore extends ReduceStore<State, Action> {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return null
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      default:
        return state
    }
  }
}

export default new TaskEditStore()
